<template>
	<div class="body">
		<div class="body-container" v-if="targetData">

			<div class="title-ch">{{targetData.title}}</div>

			<el-table :data="targetData.list" border stripe>
				<el-table-column label="年份" align="center" prop="year" />
				<el-table-column label="产业就业错配度" align="center" prop="isd" />
				<el-table-column label="职教内部高层次占比" align="center" prop="ves_h" />
				<el-table-column label="高教职教占比" align="center" prop="vhr" />
				<el-table-column label="人均GDP对数" align="center" prop="in_p_gdp" />
				<el-table-column label="协同项" align="center" prop="synergy" />
				<el-table-column label="财政教育支出对数" align="center" prop="in_edu_fis" />
				<el-table-column label="非农就业比重" align="center" prop="non_agri" />
			</el-table>
		</div>

		<div class="action-ctr">
			<el-button type="primary" icon="el-icon-download" size='medium' @click="clickNext()"
				class="next-btn">下载</el-button>
		</div>

		<el-dialog title="原理介绍" :visible.sync="showIntroDialog" append-to-body v-if="showIntroDialog" align="center">

			<div class="rich-ctr">
				<div class="rich-value" v-html="introDialog.value"></div>
			</div>


			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" @click="clickCloseIntroDialog()">确 定</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import {
		getMisRateData,
		exportMisResult
	} from "@/api/service"

	import {
		getSpanMap,
		isEmpty
	} from "@/utils/util"

	import {
		Notification,
		Message,
		Loading
	} from 'element-ui'

	import {
		parse,
		handleProtocal,
		handleRouteProtocal
	} from "@/utils/protocal"

	export default {
		name: "Famous",
		data() {
			return {
				params: {
					page: 1,
					pageSize: 20
				},
				data: null,
				showIntroDialog: false,
				introDialog: null,
				targetData: null,
				sourceData: null,
				cagrRateData: null,
				ftRateData: null,
				cagrData: null,
				ftData: null
			}
		},
		created() {
			this.initPageData();
		},

		methods: {
			initPageData() {
				this.params['id'] = this.$route.query.id;
				this.requestData();
			},

			buildParams() {
				return this.params;
			},

			requestData() {
				getMisRateData(this.buildParams()).then(res => {
					let realData = res.data;
					this.targetData = realData;

				});
			},

			clickNext() {
				exportMisResult(this.params).then(res => {
					let realData = res.data;

					window.open(realData.url, '_blank')
				})
			},

			clickRule(route) {
				if (route.type == this.variableType.File) {
					let path = route.path;
					window.open(path, '_blank')
				} else if (route.type == this.variableType.Rich) {
					this.showIntroDialog = true;
					this.introDialog = route;
				}
			},

			clickCloseIntroDialog() {
				this.showIntroDialog = false;
			}

		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "mis_rate.scss";
</style>